import { useBahasa } from '../../../app/i18n'
import { useRoster, useUbahRoster } from '../../../domains/tenancy/api'
import {
  Baris, Bendera, Chip, Gagal, Kosong, Memuat, Panel, Tabel, Tombol,
} from '../../../shared/ui'

/**
 * KETERSEDIAAN TIM — siapa yang boleh ditugaskan meeting, dan seberapa sibuk ia.
 *
 * SATU SUMBER PERHITUNGAN (ADR-026, ADR-061). Ketersediaan yang ditawarkan bot dihitung
 * `get_availability()` dari empat hal: akhir pekan, jadwal fitur `meeting`, hari yang
 * diblokir, dan hari yang sudah kepakai. Layar ini TIDAK menghitung apa pun sendiri — ia
 * memperlihatkan bahan yang masuk ke perhitungan itu, dan satu saklar yang mengubahnya.
 *
 * Kolom "Tanggal diblokir" menghitung dari HARI INI KE DEPAN. Yang sudah lewat tidak lagi
 * menahan tawaran apa pun; memasukkannya membuat angkanya tumbuh selamanya tanpa arti.
 *
 * Operator Smova tidak muncul di sini — ia berdiri di luar semua tenant, dan menugaskan
 * meeting klien kepadanya akan membuat bot menawarkan tanggal atas nama kita.
 */
export default function Ketersediaan() {
  const { t } = useBahasa()
  const q = useRoster()
  const ubah = useUbahRoster()

  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />

  const baris = q.data ?? []
  const bisa = baris.filter((o) => o.boleh_ditugaskan).length

  return (
    <div className="flex flex-col gap-3.5">
      {/* NOL ORANG YANG BISA DITUGASKAN = bot berhenti menawarkan meeting sama sekali.
          Itu tidak melempar galat di mana pun; ia cuma diam, dan yang menyadarinya orang
          yang bertanya kenapa tidak ada meeting masuk minggu ini. */}
      {baris.length > 0 && bisa === 0 && (
        <Bendera nada="bad" role="alert">{t('ta.rosterNolBisa')}</Bendera>
      )}

      <Panel judul={t('ta.rosterJudul')} catatan={t('ta.rosterCatatan')}>
        {baris.length === 0 ? (
          <Kosong judul={t('ta.rosterKosong')} keterangan={t('ta.rosterKosongKet')} />
        ) : (
          <Tabel kepala={[t('ta.kolNama'), t('ta.kolBolehDitugaskan'),
                          t('ta.kolDiblokir'), t('ta.kolMeetingBulanIni')]}>
            {baris.map((o) => (
              <Baris key={o.id}>
                <td>
                  <span className="font-semibold">{o.nama}</span>
                  <span className="block font-mono text-[10.5px] text-ink3">{o.peran}</span>
                </td>
                <td>
                  <Tombol
                    kecil
                    aria-pressed={o.boleh_ditugaskan}
                    jenis={o.boleh_ditugaskan ? 'utama' : 'sekunder'}
                    disabled={ubah.isPending}
                    onClick={() => ubah.mutate({
                      id: o.id, boleh_ditugaskan: !o.boleh_ditugaskan,
                    })}
                  >
                    {o.boleh_ditugaskan ? t('umum.ya') : t('umum.tidak')}
                  </Tombol>
                </td>
                <td className="tabular">
                  {o.tanggal_diblokir === 0
                    ? <span className="text-ink3">—</span>
                    : <Chip nada="idle">{t('ta.nHari', { n: o.tanggal_diblokir })}</Chip>}
                </td>
                <td className="tabular">{o.meeting_bulan_ini}</td>
              </Baris>
            ))}
          </Tabel>
        )}

        {ubah.isError && (
          <div className="p-3.5 border-t border-line">
            <Bendera nada="bad" role="alert">{ubah.error?.message}</Bendera>
          </div>
        )}
      </Panel>

      <Bendera nada="info" judul={t('ta.rosterSatuSumberJudul')} className="max-w-[80ch]">
        {t('ta.rosterSatuSumberIsi')}
      </Bendera>
    </div>
  )
}
